import { DOCUMENT } from '@angular/common';
import { Renderer2, inject } from '@angular/core';

export function loadFontAwesomeScript(): void {
  const src = 'https://kit.fontawesome.com/8b64096a98.js';
  const document = inject(DOCUMENT);
  const renderer = inject(Renderer2);

  const existingScript = document.querySelector(`script[src="${src}"]`);

  if (existingScript) {
    return;
  }

  const head = document.head;
  const script: HTMLScriptElement = document.createElement('script');
  script.src = src;
  script.crossOrigin = 'anonymous';

  renderer.appendChild(head, script);
}
